// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_327ff","bannerContent":"bannerContent_3tRuR","transparentBackground":"transparentBackground_24C0r"};